// extracted by mini-css-extract-plugin
module.exports = {"badge":"PreviewBadge_badge__zq8Xa","label":"PreviewBadge_label__IaZy7","dot":"PreviewBadge_dot__wtar7","pulse":"PreviewBadge_pulse__lfU0y"};